<ng-template #pContent>
  <div class="alert alert-warning mb-2 shadow-sm" role="alert">
    <i class="bi-exclamation-triangle-fill me-1"></i>
    Please ensure that releasing the brake is safe.
  </div>
  <div>
    <button type="button" class="btn btn-sm btn-primary w-100" (click)="onReleaseClick(p)">RELEASE</button>
  </div>
  <div class="form-check mt-2">
    <input
      name="show-warning"
      type="checkbox"
      class="form-check-input"
      id="show-warning"
      [ngModel]="(showBrakeWarning$ | async) === false"
      (click)="toggleShowBrakeWarning()"
    />
    <label class="form-check-label" for="show-warning"> Don't show this warning again. </label>
  </div>
</ng-template>

<div
  class="d-inline-block brake-control animate__animated animate__fadeIn"
  placement="bottom-end"
  triggers="manual"
  #p="ngbPopover"
  [ngbPopover]="pContent"
  (click)="onPopoverClick(p)"
  autoClose="outside"
  [disablePopover]="isBrakeControlledBySmm$ | async"
>
  <ng-toggle
    class="brake-control-toggle border border-secondary"
    onColor="{{ model.onColor }}"
    onText="{{ model.onText }}"
    offColor="{{ model.offColor }}"
    offText="{{ model.offText }}"
    [disabled]="toggleDisabled$ | async"
    [ngModel]="(brakeEngaged$ | async) === false"
    (valueChange)="onValueChange($event)"
  ></ng-toggle>
</div>
